const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

function hideLoadingSpinner() {
  const loadCart = document.querySelector('#loadCart');
  const btnFinish = document.querySelector('.button_finish');
  
  if (loadCart) {
    loadCart.style.opacity = "0";
    loadCart.style.visibility = "hidden";
  }
  
  if (btnFinish) {
    btnFinish.disabled = false;
  }
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (event) => event.code?.toUpperCase() === "ESCAPE" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener("shopify:section:select", () =>
      this.open()
    );
    this.parentElement.addEventListener("shopify:section:deselect", () =>
      this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector("[data-cart-link]");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() !== "SPACE") return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

	// Initialize Gift Bag component when cart drawer is opened/refreshed
  attachGiftBagDelegation() {
    // Initialize gift bag component for cart drawer
    setTimeout(function() {
      // Try different possible function names based on how Liquid processes 'cart-drawer'
      var initFunctions = [
        'initGiftBagCart-drawer',
        'initGiftBagCartDrawer',
        'initGiftBagCart_drawer', 
        'initGiftBagCartdrawer',
        'initGiftBagCart-Drawer'
      ];
      
      var initialized = false;
      for (var i = 0; i < initFunctions.length; i++) {
        if (typeof window[initFunctions[i]] === 'function') {
          window[initFunctions[i]]();
          initialized = true;
          break;
        }
      }
    }, 300);
  }

  open(opener) {
    this.attachGiftBagDelegation();

    if (opener) this.setActiveElement(opener);
    this.classList.add("is-visible");
    this.addEventListener(
      "transitionend",
      () => {
        this.focusOnCartDrawer();
        hideLoadingSpinner();
      },
      { once: true }
    );
    bodyScroll.lock(this.querySelector('[role="dialog"]'));
  }

  close() {
    this.classList.remove("is-visible");
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header.classList.contains("menu-open");

    if (isHeaderMenuOpen) {
      return;
    }

    bodyScroll.unlock(this.querySelector('[role="dialog"]'));

    // if we are on the cart page, resubmit form
    if (window.location.pathname === "/cart") {
      const cartDrawerForm = document.getElementById("CartDrawer-FormSummary");
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  static cartUpdateTimeout;
  static CART_UPDATE_DEBOUNCE = 50; // Reduced from 300ms for faster auto-gift response

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach((section) => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });

    // Dispatch cart:updated event immediately (no debounce needed now that re-renders are fixed)
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
    setTimeout(() => {
      hideLoadingSpinner();
      // Initialize empty cart slider if present
      this.initEmptyCartSlider();
    }, 100);
    
    if (!open) {
      return;
    }

    this.open();
  }

  initEmptyCartSlider() {
    // Check if empty cart slider exists and initialize it
    // Only initialize if cart is actually empty (has empty cart state)
    const cartDrawerEmpty = document.querySelector('.cart-drawer__empty');
    if (!cartDrawerEmpty) return; // Cart is not empty, don't initialize
    
    if (typeof window.initEmptyCartSlider === 'function') {
      // Find all empty cart slider containers
      const emptyCartSliders = document.querySelectorAll('.ec-empty-cart-slider');
      emptyCartSliders.forEach((slider) => {
        const sliderId = slider.id;
        if (sliderId) {
          // Check if Swiper is already initialized and working
          const swiperElement = slider.querySelector('.ec-empty-cart-slider-swiper');
          if (swiperElement && swiperElement.swiper && swiperElement.swiper.initialized) {
            // Swiper is already initialized, don't reinitialize
            return;
          }
          window.initEmptyCartSlider(sliderId);
        }
      });
    }
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();
    
    // Observar mudanças no DOM para detectar quando itens são adicionados/removidos
    const observer = new MutationObserver(() => {
      setTimeout(() => {
        hideLoadingSpinner();
      }, 100);
    });
    
    observer.observe(this, {
      childList: true,
      subtree: true
    });
  }
  
  getSectionsToRender() {
    return sectionsToRender;
  }
  
  async updateQuantity(line, quantity, name, lineKey) {
    this.classList.add('is-loading');

    try {
      // Check if AutoGiftHandler is enabled
      const autoGiftConfig = window.autoGiftConfig;
      const hasAutoGiftEnabled = autoGiftConfig && 
                                  ((autoGiftConfig.enabled && autoGiftConfig.productId) || 
                                   (autoGiftConfig.enabled2 && autoGiftConfig.productId2));
      
      if (!autoGiftConfig || !hasAutoGiftEnabled) {
        // No auto-gifts enabled - use standard flow with sections
        const fetchUrl = routes.cart_change_url;
        const fetchBody = JSON.stringify({
          ...(lineKey ? { id: lineKey } : { line }),
          quantity,
          sections: this.getSectionsToRender().map(
            section => section.section
          ),
          sections_url: window.location.pathname
        });

        const response = await fetch(fetchUrl, {
          ...fetchConfig(),
          ...{ body: fetchBody }
        });
        
        const state = await response.text();
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        
        this.updateLiveRegions(line, parsedState.item_count, quantity);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
        
        // Check if cart became empty and initialize slider
        const cartDrawer = document.querySelector('cart-drawer');
        const cartBecameEmpty = parsedState.item_count === 0;

         document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: parsedState,
            source: 'updateQuantity',
            deferUIUpdate: true
          }
        }));

        setTimeout(() => {
          hideLoadingSpinner();
          // Initialize empty cart slider if cart became empty
          if (cartBecameEmpty && cartDrawer && typeof cartDrawer.initEmptyCartSlider === 'function') {
            cartDrawer.initEmptyCartSlider();
          }
        }, 100);
        
        this.classList.remove('is-loading');
        return;
      }
      
      // Auto-gifts enabled - defer UI update to AutoGiftHandler
      const fetchUrl = routes.cart_change_url;
      const fetchBody = JSON.stringify({
        ...(lineKey ? { id: lineKey } : { line }),
        quantity
      });

      const response = await fetch(fetchUrl, {
        ...fetchConfig(),
        ...{ body: fetchBody }
      });
      
      const state = await response.text();
      const parsedState = JSON.parse(state);
      
      // Dispatch cart:updated event with cart data
      // AutoGiftHandler will check if gifts need to be added/removed and update UI once
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { 
          cart: parsedState,
          source: 'updateQuantity',
          skipAutoGift: false,
          deferUIUpdate: true // Signal that UI update should be handled by AutoGiftHandler
        } 
      }));
      
      this.updateLiveRegions(line, parsedState.item_count, quantity);

    } catch (error) {
      showCartItemError(
        line,
        'Não foi possível atualizar este item. Tente novamente.'
      );
      this.classList.remove('is-loading');
    }
    // Note: is-loading class will be removed after AutoGiftHandler completes (if enabled)
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, quantity) {
    // Only surface the "you can only add X" limit message on a real quantity
    // increase that got clamped — never on removals (quantity 0) or background
    // re-renders, which would otherwise show a false positive on the wrong line.
    if (quantity !== 0 && this.currentItemCount === itemCount) {
      document
        .querySelectorAll(
          `[data-line-item-error][data-line="${line}"]`
        )
        .forEach(error => {
          error.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.querySelector(`[id*="ProductQuantity-${line}"]`)
              .value
          );
        });
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
